import axios from 'axios'
import io from 'socket.io-client'
import { apiUrl, socketURL } from './config'

console.log('socketURL', socketURL)
let socket = {}

// In-memory Promise that resolves when the SECRET_KEY is available
socket._secretKeyPromise = null;
socket._secretKeyCache = null;

socket.connect = function() {
  // socket.io = io(socketURL)
  socket.io = {};
  return this
}

socket.getConnection = function() {
  console.log(socketURL)
  if (socket) {
    return this.io
  } else {
    socket = io(socketURL)
    return this.io
  }
}

socket.on = function(eventName, callback) {
  console.log("eventName", eventName)
  if(eventName == 'SECRET_KEY'){
    // Wait for the emit to complete rather than a fixed timeout
    // Key is held in memory only; never stored in localStorage/sessionStorage/cookies
    if (socket._secretKeyPromise) {
      socket._secretKeyPromise.then(() => {
        callback(socket._secretKeyCache);
      });
    } else {
      // Fallback: poll until key is available (max 10s)
      let attempts = 0;
      const poll = setInterval(() => {
        attempts++;
        if (socket._secretKeyCache) {
          clearInterval(poll);
          callback(socket._secretKeyCache);
        } else if (attempts > 50) {
          clearInterval(poll);
          console.error("SECRET_KEY not available after timeout");
          callback(null);
        }
      }, 200);
    }
    return this;
  }
  // socket.io.on(eventName, callback)
  axios.get(
    apiUrl +
      'api/' +
      (eventName == 'CLIENT_PRIVATE_KEY' || eventName == 'CLIENT_PUBLIC_KEY'
        ? "INIT"
        : "INIT_ACK")
  )
  .then(response => {
    callback(response.data.data);
  })
  
  return this
}

socket.emit = function(eventName, data) {
  // socket.io.emit(eventName, data)
  const request = axios.post(apiUrl + 'api/' + (eventName == 'CLIENT_PRIVATE_KEY' ? "INIT" : "INIT_ACK"), {data})
  .then(response => {
    // Store secret key only in memory, never in localStorage/sessionStorage/cookies
    if (eventName === 'SECRET_KEY') {
      socket._secretKeyCache = response.data.data;
    }
    return response;
  })

  // Track the SECRET_KEY request so .on() can await it
  if (eventName === 'SECRET_KEY') {
    socket._secretKeyPromise = request;
  }

  return request;
}

export default socket
